import { useUserAuth } from "../context/UserAuthContext";

const ClassInfo = ({ classInfo, studentCount, subjectCount, expectedIncome, actualIncome, outstandingBalance, setShowPromoteModal }) => {
  const { userData } = useUserAuth(); // Get logged-in user data

  const canViewFinances = userData?.status === 'Cashier' || userData?.level === 'Supreme';

  const formatCurrency = (amount) => {
    return `₦ ${Number(amount).toLocaleString()}`;
  };

  return (
    <div className="info-section tab-section">      
      <div className="tab-section-top column align-center">
        <button className='tab-section-button caps' onClick={() => setShowPromoteModal(true)}>Promote Class</button>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">Class</span><br />
        <span>{classInfo.name}</span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">Section</span><br />
        <span>{classInfo.section}</span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">Session</span><br />
        <span>{classInfo.session}</span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">Term</span><br />
        <span>{classInfo.term}</span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">Form Master</span><br />
        <span>{classInfo.formMaster 
        ? `${classInfo.formMaster.firstName} ${classInfo.formMaster.lastName}`
        : 'N/A'}
        </span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">No of Students</span><br />
        <span>{studentCount}</span>
      </div>
      <div className="info-item info-item1">
        <span className="font-gold bold size5">No of Subjects</span><br />
        <span>{subjectCount}</span>
      </div>

      {canViewFinances && (
        <>
          <div className="info-item info-item1">
            <span className="font-gold bold size5">Expected Income</span><br />
            <span>{formatCurrency(expectedIncome)}</span>
          </div>
          <div className="info-item info-item1">
            <span className="font-gold bold size5">Actual Income</span><br />
            <span>{formatCurrency(actualIncome)}</span>
          </div>
          <div className="info-item info-item1">
            <span className="font-gold bold size5">Outstanding Balance</span><br />
            <span>{formatCurrency(outstandingBalance)}</span>
          </div>
        </>
      )}        
    </div>
  );
};

export default ClassInfo;
